'use strict';

import React, { Component } from 'react';
import { isEmpty } from "lodash";
import SingleSalePopUp from '../Stock/sales/SingleSalePopUp';
import Currency from '../../../commonModules/Currency';
import {  Box, TableBody, TableRow, TableCell } from '@material-ui/core';
import { StorefrontRounded, CloudDownloadRounded } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { TableLayout } from '../Stock/containers/Layout';
import StockExtractButton from '../Stock/StockExtractButton';

// YAYA Aboubacar Parakou

class StoreHouseEquipment extends Component{
    state = {
        equipmentIDList: [],
        equipmentList: [],
        selectedSale: "",
        openSale: true
    }
   
    componentDidMount = async () =>  {
        this.getEquipmentDetails()
    }
    getEquipmentDetails = async () => {
        var url = "/equipment/fromstorehouse/details?boxAssoId=" + this.props.boxAssoId;
        try {
            let req = await fetch(url,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){
                if (res.List && res.List.length > 0){
                    this.setState({equipmentList: res.List});
                }
            } else {
                console.log("[ERROR] get equipment/fromstorehouse ", res.error);
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] get equipment/fromstorehouse ", error);
            console.log('====================================');
        }
    }
    // getEquipmentList = async () => {
    //     var url = "equipment/fromstorehouse/list?boxAssoId=" + this.props.boxAssoId;
    //     try {
    //         let req = await fetch(url,{
    //             method:'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
    //             },
    //             credentials: 'same-origin',
       
    //         })
    //         const res = await req.json()
    //         console.log({res});
            
    //         if(res.error === "OK"){
    //             if (res.List && res.List.length > 0){
    //                 this.setState({equipmentIDList: res.List});
    //             }
    //         } else {
    //             console.log("[ERROR] get equipment/fromstorehouse ", res.error);
    //         }
    //     } catch (error) {
    //         console.log('====================================');
    //         console.log("[ERROR] get equipment/fromstorehouse ", error);
    //         console.log('====================================');
    //     }
    // }
    openSale = ( saleID ) => {
        this.setState({
            selectedSale: saleID,
            openSale: !!saleID
        })
    }

    render() {
        const {equipmentList, selectedSale, openSale} = this.state;
        console.log('================STATE====================');
        console.log(this.state);
        console.log('====================================');
        return (
            !isEmpty(equipmentList) ?
            <MiniCard
                title="Equipement Description"
                avatar={<StorefrontRounded />}
                action={<StockExtractButton
                    icon={<CloudDownloadRounded />}
                    color="primary"
                    title="Télécharger la liste"
                    extract="client_sale_list"
                    product_id={this.props.boxAssoId}
                />}
            >
                {/* BODJRENOU Robert / 312 */}
                <Box>
                    { openSale && !isEmpty(selectedSale) &&
                        // <PopUp close={() => this.openSale()} title={`Vente n° ${selectedSale}`}>
                        <SingleSalePopUp saleID={selectedSale} closeSale={() => this.openSale()}/>
                        // </PopUp>
                    }
                    <TableLayout>
                        <TableBody>
                            {equipmentList.map( (item, i) =>  
                                <TableRow hover key={`${item.product.name}-${i}`} onClick={() => this.openSale(item.sale_id)}>
                                    <TableCell component="th">{item.product.name}</TableCell>
                                    {item.rest_to_return !== item.quantity ? 
                                        <TableCell><b style={{ color: "blueviolet"}}>{item.rest_to_return}</b> / {item.quantity} </TableCell>
                                    : 
                                        <TableCell>{item.quantity}</TableCell>
                                    }
                                    <TableCell><Currency value={Math.round(item.price)} round /></TableCell> {/* price == stock cost total */}
                                </TableRow>
                            )}

                        </TableBody>
                    </TableLayout>
                </Box>
            </MiniCard>
            : ""

        )
    }
};
export default StoreHouseEquipment
